<ion-menu side="end" menuId="mobileMenu" contentId="main-content">

  <ion-content class="bg-gradient">
    <div class="flex flex-col gap-2 p-4 text-white">
      <a (click)="router.navigateByUrl('/app/home')" class="flex items-center gap-4 w-full px-6 py-2">
        <ion-icon slot="start" src="../../assets/svg/home.svg"></ion-icon>
        <ion-label>{{ "HEADER_WEB.HOME" | translate }}</ion-label>
      </a>
      <a *ngIf="isLoggedIn()" (click)="router.navigateByUrl('/app/notifications')" class="flex items-center gap-4 w-full px-6 py-2">
        <div class="relative">
          <ion-icon slot="start" src="../../assets/svg/bell.svg"></ion-icon>
          <div *ngIf="hasUnreadNotifications()" class="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full"></div>
        </div>
        <ion-label>{{ "HEADER_WEB.NOTIFICATIONS" | translate }}</ion-label>
      </a>
      <a
        *ngFor="let item of menuToShow()"
        [routerLink]="item.link"
        [className]="
          item.avatar
            ? 'flex items-center gap-2 w-full px-4 py-2'
            : 'flex items-center gap-4 w-full px-6 py-2'
        "
      >
        @if (item.avatar) {
          <div
            class="h-8 aspect-square rounded-full !bg-cover !bg-center"
            [ngStyle]="{
            background:
              'url(' +
              (user()?.publicProfile?.photo_perfil ??
                '../../../assets/images/user1.jpg') +
              ')'
          }"
          ></div>
        } @else {
          <ion-icon slot="start" [src]="item.icon"></ion-icon>
        }
        <ion-label>{{ item.label }}</ion-label>
      </a>
      <a
        (click)="openLogoutDialog()"
        *ngIf="user()"
        class="flex items-center gap-4 w-full px-6 py-2"
      >
        <ion-icon slot="start" src="../../assets/svg/logout.svg"></ion-icon>
        <ion-label>{{ "HEADER_WEB.LOGOUT" | translate }}</ion-label>
      </a>

      <!-- Language dropdown for mobile web menu -->
      <div class="mt-2">
        <button class="flex items-center justify-between w-full px-6 py-2" (click)="toggleLangs()">
          <div class="flex items-center gap-4">
            <ion-icon slot="start" name="globe-outline"></ion-icon>
            <ion-label>{{ 'ACCOUNT.LANGUAGE' | translate }}</ion-label>
          </div>
          <ion-icon [name]="showLangs() ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
        </button>
        <div *ngIf="showLangs()" class="flex flex-col pl-14 pr-6 py-2 gap-2">
          <button *ngFor="let language of langs()" class="flex items-center gap-3 text-left" (click)="selectLanguageAndReload(language)">
            <div
              class="h-5 w-5 min-w-5 rounded-full bg-no-repeat bg-cover bg-center"
              [ngStyle]="{ 'background-image': 'url(' + language.flag + ')' }"
            ></div>
            <ion-label class="uppercase text-sm">{{ language.value }}</ion-label>
          </button>
        </div>
      </div>
    </div>
  </ion-content>
</ion-menu>

<!-- CONTENIDO PRINCIPAL -->
<div id="main-content">
  <div class="flex justify-between items-center p-4 bg-[#4FC2EC]">
    <a (click)="router.navigateByUrl('/app/home')">
      <ion-img
        src="../../../assets/images/Logo FOUNDEK-19.png"
        class="w-[180px] md:w-[230px]"
      ></ion-img>
    </a>

    @if (isMobile()) {
      <ion-button fill="clear" mode="ios" color="light" (click)="openMenu()">
        <ion-icon name="menu-outline"></ion-icon>
      </ion-button>
    } @else {
      <div class="flex items-center space-x-2">
        <ion-button
          fill="clear"
          mode="ios"
          *ngIf="isLoggedIn()"
          id="notificationsPopover"
        >
          <div class="relative">
            <ion-icon
              slot="icon-only"
              src="../../../assets/svg/bell.svg"
            ></ion-icon>
            <!-- Indicador de notificaciones sin leer -->
            <div
              *ngIf="hasUnreadNotifications()"
              class="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full"
              [attr.aria-label]="'HEADER_WEB.UNREAD_NOTIFICATIONS' | translate"
            ></div>
          </div>
        </ion-button>

        <ion-button fill="clear" mode="ios" color="light" (click)="router.navigateByUrl('/app/home')">
          <ion-label>{{ "HEADER_WEB.HOME" | translate }}</ion-label>
        </ion-button>

        <!-- Menú dinámico -->
        <ion-button
          fill="clear"
          mode="ios"
          color="light"
          *ngFor="let item of menuToShow()"
          (click)="router.navigateByUrl(item.link)"
          [id]="item.avatar ? 'accountPopover' : ''"
        >
          @if (item.avatar) {
            <div
              class="h-8 aspect-square rounded-full !bg-cover !bg-center"
              [ngStyle]="{
            background:
              'url(' +
              (user()?.publicProfile?.photo_perfil ??
                '../../../assets/images/user1.jpg') +
              ')'
          }"
            ></div>
          } @else {
            <ion-label>{{ item.label }}</ion-label>
          }
        </ion-button>

        <ion-button fill="clear" mode="ios" id="customPopover">
          <ion-icon name="globe-outline" color="light"></ion-icon>
          <ion-label class="ml-2 lowercase" color="light">
            {{ selectedLanguage().value }}
          </ion-label>
        </ion-button>

        <!-- Popovers -->
        <ion-popover
          trigger="notificationsPopover"
          [dismissOnSelect]="false"
          alignment="start"
          size="cover"
          arrow="false"
          class="notifications"
        >
          <ng-template>
            <ion-content class="notifications-content">
              <app-web-notifications
                (onCloseBox)="closeBox()"
                (toggle)="toggleShow($event)"
              ></app-web-notifications>
            </ion-content>
          </ng-template>
        </ion-popover>

        <ion-popover
          trigger="customPopover"
          [dismissOnSelect]="true"
          alignment="start"
          size="cover"
          arrow="false"
        >
          <ng-template>
            <ion-content class="popover-content" scroll-y="false">
              <div class="flex flex-col gap-6 py-2">
                <div
                  *ngFor="let language of langs()"
                  (click)="selectLanguage(language)"
                  class="cursor-pointer flex gap-3 px-3"
                >
                  <div
                    class="h-5 w-5 min-w-5 rounded-full bg-no-repeat bg-cover bg-center cursor-pointer"
                    [ngStyle]="{
                    'background-image': 'url(' + language.flag + ')'
                  }"
                    slot="start"
                  ></div>
                  <ion-label
                    color="light"
                    class="uppercase font-semibold text-sm"
                  >
                    {{ language.value }}
                  </ion-label>
                </div>
              </div>
            </ion-content>
          </ng-template>
        </ion-popover>
      </div>

    }

    <!-- Menú completo para escritorio -->
  </div>

  <!-- MODAL NOTIFICACIONES -->
  <app-dialog [show]="show()" (toggle)="toggleShow($event)">
    <ion-button
      mode="ios"
      fill="clear"
      (click)="toggleShow($event)"
      class="absolute top-0 right-0"
    >
      <ion-icon
        color="secondary"
        src="../../../assets/svg/close.svg"
        class="text-[20px]"
      />
    </ion-button>
    <ion-label class="text-[10px] font-bold">
      {{ notificationSelected().date }} - {{ notificationSelected().time }}
    </ion-label>
    <ion-label class="text-sm mt-4">{{
        notificationSelected().text
      }}
    </ion-label>
  </app-dialog>

  <!-- MODAL LOGOUT -->
  <app-dialog
    type="confirm"
    [show]="showLogout()"
    (toggle)="closeLogoutDialog()"
    (confirm)="confirm()"
  >
    <ion-label color="secondary">{{
        "HEADER_WEB.LOGOUT_TITLE" | translate
      }}
    </ion-label>
    <ion-label class="text-[13px] mt-4 text-[#131C4F]">
      {{ "HEADER_WEB.LOGOUT_CONFIRM" | translate }}
    </ion-label>
  </app-dialog>
</div>
